import { getContractLocations } from "../../services/ContractLocationService";
import { CL_CONFIRMED_ACTION, CL_FAILED_ACTION } from "./actionTypes";
export function getContractLocationsAction() {
    return (dispatch) => {
        getContractLocations()
            .then((response) => {
                dispatch(confirmedContractLocationsAction(response));
            })
            .catch((error) => {
                const errorMessage = error.response ? error.response.data : 'Network Error';
                dispatch(contractLocationsFailedAction(errorMessage));
            });
    };
}

export function confirmedContractLocationsAction(payload) {
    return {
        type: CL_CONFIRMED_ACTION,
        payload,
    };
}

export function contractLocationsFailedAction(data) {
    return {
        type: CL_FAILED_ACTION,
        payload: data,
    };
}
